export default "__VITE_ASSET__3e57e36c__"